// extracted by mini-css-extract-plugin
export var commentIcon = "comment-icon__lV0u";